import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RestApiModel } from '../model/rest-api.model';

const vixxoLinkAPIURI: string = RestApiModel.PROXY_Link_API_URL;

@Injectable()
export class IndexLoggingService {
  constructor(private httpClient: HttpClient, private injector: Injector) {}

  private getAPIURL(endpoint: string): string {
    return `${vixxoLinkAPIURI}/${endpoint}`;
  }

  /**
   * Error Handler
   * @param error
   * @returns {any}
   */
  private handleError(error: Response | any): Observable<any> {
    if (error.status === 401) {
      let router = this.injector.get(Router);
      router.navigate(['access-unauthorized']);
      return of([]);
    } else {
      return Observable.throwError(error);
    }
  }

  public postRequest(endpoint: string, params: Object = {}): Observable<any> {
    if (!endpoint) {
      return;
    }
    const url = this.getAPIURL(endpoint);
    return this.httpClient.post(url, params).catch(err => {
      return this.handleError(err);
    });
  }

  postLogginIndex(indexName: string, apiDocument: any): any {
    const params = {
      document: apiDocument
    };
    return this.postRequest(`logIndex/${indexName}`, params);
  }
}
